import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  saveBtn: {
    flex: 1,
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    flex: 1,
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    backgroundColor: "#F5F5F5",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F5F5F5",
      opacity: 0.8,
    },
  },
  formBox: {
    width: "100%",
    padding: "26px 13px 18px 13px",
    borderRadius: 12,
    border: "1px solid #E5E5EA",
    backgroundColor: "#FFF",
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#262626",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "10px 14px",
      height: 44,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "transparent",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      '&:has(input:disabled)':{
        background: "#f7f7f7 !important"
      },
      "& input, & .mantine-PasswordInput-input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "#737373",
        },
      },
    },
    "& .mantine-Select-wrapper": {
      padding: 0,
      "& .mantine-Select-input": {
        paddingLeft: 12,
        paddingRight: 36,
      },
    },
  },

  servicesSection: {
    "& .hdng": {
      fontSize: 18,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#000",
      marginBottom: 14,
    },
    "& .grayBox": {
      borderRadius: 8,
      border: "1px solid #E5E5E5",
      backgroundColor: "#FCFCFC",
      padding: "18px 14px",
      display: "flex",
      flexDirection: "column",
      gap: 18,
      "& .services": {
        paddingInline: 21,
        borderBottom: "1px solid #E4E4E7",
        paddingBottom: 19,
        "& .label": {
          margin: 0,
          fontSize: 14,
          fontWeight: 500,
          fontFamily: "Inter",
          color: "#171717",
          marginBottom: 12,
        },
        "& .servicesParent": {
          padding: "16px 24px",
          borderRadius: 8,
          border: "1px solid #E7EBEF",
          backgroundColor: "#FAFAFA",
          flexWrap: "wrap",
          gap: 24,
          "& .mantine-Checkbox-root": {
            width: "calc(50% - 12px)",
            "& .mantine-Checkbox-label": {
              fontSize: 12,
              fontWeight: 400,
              fontFamily: "Inter",
              color: "#737373",
            },
            "& .mantine-Checkbox-input": {
              border: "1px solid #262626",
              borderRadius: 6,
              backgroundColor: "#FCFCFD",
              "&:checked": {
                backgroundColor: "#27272A",
                borderColor: "#27272A",
              },
            },
          },
        },
      },
    },
  },
  noteTextArea: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#262626",
      marginBottom: 6,
    },
    "& .mantine-Textarea-input": {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 400,
      color: "#737373",
      padding: "10px 14px",
      borderRadius: 8,
      border: "1px solid #E5E5E5",
      backgroundColor: "#FAFAFA",
      minHeight: 150,
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    },
  },

  actionsRow: {
    width: "100%",
    gap: 16,
    marginTop: 24,
  },

  datePickerInput: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#262626",
      marginBottom: 6,
    },
    "& .mantine-DatePickerInput-input": {
      color: "#262626",
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 600,
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      backgroundColor: "#FFF",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px #F2F4F7",
      height: 40
    },
  },
}));

export default useStyles;
